export const SET_ANNOUNCEMENT = "SET_ANNOUNCEMENT";
export const SET_UPCOMING = "SET_UPCOMING";
export const SET_PREVIOUS = "SET_PREVIOUS";
export const SET_LOGGED = "SET_LOGGED";
export const SET_ANNOUNCEMENT_OPTIONS = "SET_ANNOUNCEMENT_OPTIONS";
export const GET_ANNOUNCEMENT = "GET_ANNOUNCEMENT";
export const REFRESH_ANNOUNCEMENT = "REFRESH_ANNOUNCEMENT";